module.exports = __webpack_public_path__ + "assets/certificate_pdf/CIW Web Security Associate_CIW Certified Internet Web Professional_20170331.8cd85aa3.pdf";